import PropTypes from 'prop-types';
import { Component } from 'react';

import Button from 'hb-react/frontoffice/components/Button';
import { DefaultLink } from 'hb-react/frontoffice/components/Link';
import ContentPreview from 'hb-react/shared/components/ContentPreview';

class FooterButtons extends Component {
  static renderReadme(htmlBlock) {
    const button = (
      <Button
        className="button color-black button--wide absolute deprecated--visuallyhidden--palm south west push floating-animation"
        testid="header-readme"
      >
        <div>{I18n.t('web.shared.readme')}</div>
      </Button>
    );

    return (
      <ContentPreview
        portalProps={{
          openByClickOn: button,
          closeOnEsc: false,
          closeOnOutsideClick: false,
        }}
        size="medium"
        screenReadersTitle={s__('Accessibility|More info window')}
        screenReadersCloseButtonText={s__(
          'Accessibility|Close more info window',
        )}
      >
        <div
          className="soft"
          dangerouslySetInnerHTML={{
            __html: htmlBlock,
          }}
        />
      </ContentPreview>
    );
  }

  static renderDownload(link) {
    return (
      <DefaultLink
        className="button button--white button--wide absolute palm--static south east push"
        href={link || ''}
        target="_blank"
        data-name="external-document"
      >
        {I18n.t('web.memberships.offline_payment_document')}
      </DefaultLink>
    );
  }

  render() {
    const { html_block: htmlBlock, link } = this.props;

    return (
      <div>
        {!!htmlBlock && FooterButtons.renderReadme(htmlBlock)}
        {link && FooterButtons.renderDownload(link)}
      </div>
    );
  }
}

FooterButtons.propTypes = {
  html_block: PropTypes.string,
  link: PropTypes.string,
};

export default FooterButtons;
